$(document).ready(function(){
    $('.related-projects__mobile').slick({
        arrows: false,

    });
});